import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import {MembershipAncillariesView} from './view';
import {MembershipAncillariesModel} from './model';
import {WIDGET_NAME} from './constants';
import {initData, isSubscriptionAdded} from './utils';
import {getResultFullFareSelected} from 'od-modules/utils/membership_utils';

const factory = createWidgetFactory({
    name: WIDGET_NAME,
    modelClass: MembershipAncillariesModel,
    viewClass: MembershipAncillariesView,
    methods: {
        initialize() {
            const isFullFareSelected = getResultFullFareSelected();
            const membershipFee = this.model.get('membershipFee');
            const data = {...initData(isFullFareSelected, membershipFee)};
            const {isPrimeFareSelected, membershipDiscount, name, lastName} = data;
            const widgetId = this.id;
            const quantity = isPrimeFareSelected ? 1: 0;
            const hasToAddProduct = quantity === 1;
            const {toBeDisplayed} = this.model.getCustomerAccount();
            this.model.getMembershipOffer();
            if (toBeDisplayed) {
                const membershipInfo = {widgetId, name, lastName, quantity};
                this.model.set({
                    membershipInfo,
                    isPrimeFareSelected,
                    quantity,
                });
                this.render({...data, membershipDiscount});
                this.model.propagateMembershipProduct(widgetId, hasToAddProduct);
            } else {
                this.$el.empty();
            }
        },
        getMembershipInfo() {
            return this.model.get('membershipInfo');
        },
        isSubscriptionAdded() {
            return isSubscriptionAdded(this.model.get('primeMemberSelected'));
        },
        addPrime() {
            const isFullFareSelected = this.model.get('isPrimeFareSelected');
            return this.addPrime(isFullFareSelected);
        },
        removePrime() {
            const isFullFareSelected = !this.model.get('isPrimeFareSelected');
            return this.removePrime(isFullFareSelected);
        },
        updateMembershipProduct() {
            return this.model.updateMembershipProduct();
        },
        propagateMembershipProduct() {
            this.model.propagateMembershipProduct(this.id);
        },
        initializeWithMock(params) {
            const {isPrimeFareSelected, keys} = params;
            const membershipDiscount = Odigeo.Utils.formatCurrency(Math.abs(params.membershipDiscount));
            this.model.getMembershipOffer();
            this.render({isPrimeFareSelected, membershipDiscount, keys});
        },
        toggleShowPendingPrimeDecisionMessage() {
            return this.toggleShowPendingPrimeDecisionMessage();
        },
        toggleShowMembershipAncillariesWidget() {
            this.toggleShowMembershipAncillariesWidget();
        },
        shouldRequestForRiskyCardNumber(ccnumber) {
            this.requestForRiskyCardNumber(ccnumber);
        },
    },
    isEnabled() {
        return Odigeo.Membership.isMembershipProductEnabledDesktop || Odigeo.Membership.isPrimeMobile;
    },
});

function createEventsMap(id) {
    return {
        [`${id}:openMembershipPerksInfoLightbox`]: 'onOpenMembershipPerksInfoLightbox',
        [`${id}:updateMembershipPricePayment`]: 'onUpdateMembershipPricePayment',
        [`${id}:updatePageStatus`]: 'onUpdatePageStatus',
        [`${id}:openLoginForm`]: 'onOpenLoginForm',
    };
}

export default {
    factory,
    createEventsMap,
};
